<template>
  <b-container fluid class="pb-4">
    <!-- 製品種別マスタメンテ編集 -->
    <h1 class="fc-h1">{{ $i18n.t("codemente.title") }}{{ $i18n.t("codemente.label_edit") }}</h1>
    <form>
    <!-- 編集 -->
      <b-card :title="this.$i18n.t('codemente.label_edit')" class="w-50">
            <!-- 型番 -->
            <b-form-group
              id="code"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('codemente.label_code')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="code" disabled :placeholder="this.$i18n.t('codemente.placeholder_code')"></b-form-input>
            </b-form-group>
            <!-- レビジョン -->
            <b-form-group
              id="revision"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('codemente.label_revision')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="revision" disabled :placeholder="this.$i18n.t('codemente.placeholder_revision')"></b-form-input>
            </b-form-group>
            <!-- モデル名 -->
            <b-form-group
              id="petname"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('codemente.label_petname_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="petname" maxlength="45" :placeholder="this.$i18n.t('codemente.placeholder_petname')"></b-form-input>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="back" class="float-left px-5">{{ $i18n.t("codemente.label_back") }}</b-button>
            </div>
            <div>
              <!-- 更新 -->
              <b-button variant="primary" @click="regist" class="float-right px-5">{{this.$i18n.t('codemente.button_update')}}</b-button>
            </div>
      </b-card>
    </form>
    <!-- 製品種別を更新しました。 -->
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('codemente.info_update')" :titleMsg="this.$i18n.t('codemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <!-- モデル名は必須です。 -->
    <confirm-modal modId="md-errPetnameHissu" :msg="this.$i18n.t('codemente.err_petname_hissu')" :titleMsg="this.$i18n.t('codemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errPetnameHissuConfirm"/>
    <!-- その他エラー -->
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      code: null,
      revision: null,
      petname: null,
      searchCode: null,
      searchRev: null,
      searchPetname: null,
      efFlg: true,
      currentPage: 1,
      perPage: 5,
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      errSbj: '',
      errMsg: ''
    }
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var editId = this.$store.store.state.editId
    var code = editId[0]
    var rev = editId[1]

    var body = {}
    // 入力値を設定
    body.code = code
    body.codeLikeFlg = '0'
    body.rev = rev
    body.revLikeFlg = '0'
    body.petname = ''
    body.efFlg = ''

    // 型番取得
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/master/productinfo/select', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        } else {
          var productInfoList = res.data.productInfo

          // 整形
          this.code = productInfoList[0].code
          this.revision = productInfoList[0].rev
          this.petname = productInfoList[0].petname
        }
      })
      .catch(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('common.unexpected_error')
        this.$bvModal.show('md-err')
      })

    // 検索条件セット
    this.searchCode = this.$store.store.state.searchCode
    this.searchRev = this.$store.store.state.searchRev
    this.searchPetname = this.$store.store.state.searchPetname
  },
  methods: {
    regist: function () {
      // 入力値チェック
      if (this.petname === null || this.petname === '') {
        this.$bvModal.show('md-errPetnameHissu')
        return
      }
      if (!window.checkProhibitedLetters(this.petname)) {
        this.errSbj = this.$i18n.t('codemente.title')
        this.errMsg = this.$i18n.t('codemente.err_petname_symbol')
        this.$bvModal.show('md-err')
        return
      }
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      // 入力値を設定
      body.code = this.code
      body.rev = this.revision
      body.petname = this.petname

      // 型番更新
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/productinfo/update', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 登録メッセージ表示
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          alert(res)
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    back: function () {
      var searchFlg = 1
      var path = '/codemente'
      this.$router.push({ path: path, query: {searchFlg: [searchFlg], searchCode: [this.searchCode], searchRev: [this.searchRev], searchPetname: [this.searchPetname]} })
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm')
    },
    errPetnameHissuConfirm: function () {
      this.$bvModal.hide('md-errPetnameHissu')
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  },
  routes: [
    {
      path: '/codemente/:searchFlg/:searchCode/:searchRev/:searchPetname',
      name: 'codemente',
      components: './Codemente.vue'
    }
  ]
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CodementeEdit.vue